import SideBar from "../../components/SideBar";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps, null)(SideBar);
